export default {
    getPlanChargeTypes: { method: 'get', url: 'emcadmin/charge-types' },
    postPlanChargeTypes: { method: 'post', url: 'emcadmin/charge-types' },
    putPlanChargeTypes: { method: 'put', url: 'emcadmin/charge-types/{id}' },
    deletePlanChargeTypes: { method: 'delete', url: 'emcadmin/charge-types/{id}' },
}
